<script setup lang="ts">
withDefaults(defineProps<{ size?: number | string; color?: string }>(), {
  size: 24,
  color: "currentColor",
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 4.8C8.02355 4.8 4.8 8.02355 4.8 12C4.8 15.9765 8.02355 19.2 12 19.2V4.8ZM3 12C3 7.02943 7.02943 3 12 3C12.3373 3 12.6706 3.01859 12.9989 3.05488C17.4998 3.55244 21 7.36684 21 12C21 16.6332 17.4998 20.4476 12.9989 20.9451C12.6706 20.9814 12.3373 21 12 21C7.02943 21 3 16.9705 3 12Z"
    />
  </svg>
</template>
